import CarrierPricingCostsForm from 'components/forms/CarrierFormFactory/CarrierPricingCostsForm';
import { useOperatorsPricingRulesQuery } from 'api/queries/operators';

function PricingOpCostsView() {
  const { data: pricingRules, isSuccess } = useOperatorsPricingRulesQuery();

  if (!isSuccess) return null;
  return <CarrierPricingCostsForm defaultValues={pricingRules} />;
}

export default PricingOpCostsView;
